import { render, staticRenderFns } from "./modifyTel.vue?vue&type=template&id=54f7a7eb&scoped=true"
import script from "./modifyTel.vue?vue&type=script&lang=js"
export * from "./modifyTel.vue?vue&type=script&lang=js"
import style0 from "./modifyTel.vue?vue&type=style&index=0&id=54f7a7eb&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54f7a7eb",
  null
  
)

export default component.exports